import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AppContextProvider } from './context/AppContext'
import { OrgContextProvider } from './contexts/OrgContext'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <OrgContextProvider>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </OrgContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
